<template>
  <div class="login-wrapper">
    <img class="logo" :src="logo" />
    <el-form
      ref="login"
      :model="form"
      label-width="0"
      style="width: 100%"
      @keydown.enter.native="submit"
    >
      <!-- Github登录方式 -->
      <el-form-item prop="userID">
        <!-- <el-input v-model="form.userID" placeholder="请输入用户名" type="text" clearable></el-input> -->
        <el-select v-model="form.userID" class="user-selector">
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 线上版本登录方式 -->
      <!-- <el-form-item prop="userID">
        <el-input v-model="form.userID" placeholder="请输入用户名" type="text" clearable></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="form.password"
          placeholder="请输入密码"
          type="password"
          show-password
          clearable
        ></el-input>
      </el-form-item>-->
    </el-form>
    <el-button
      type="primary"
      @click="submit"
      style="width: 100%; margin-top: 6px"
      :loading="loading"
      >登录</el-button
    >
  </div>
</template>

<script>
import { Form, FormItem, Select, Option } from "element-ui";
import axios from "axios";
export default {
  name: "Login",
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElSelect: Select,
    ElOption: Option,
  },
  data() {
    const checkUserID = (rule, value, callback) => {
      if (!/^[a-zA-Z][a-zA-Z0-9_]{3,23}$/.test(value)) {
        callback(new Error("不合法（字母开头+字母/数字，长度4-24)"));
      } else {
        callback();
      }
    };

    return {
      form: {
        userID: "",
        password: "",
      },
      options2: [
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
        {
          value: "4",
          label: "4",
        },
        {
          value: "5",
          label: "5",
        },
        {
          value: "6",
          label: "6",
        },
        {
          value: "7",
          label: "7",
        },
        {
          value: "8",
          label: "8",
        },
        {
          value: "9",
          label: "9",
        },
        {
          value: "10",
          label: "10",
        },
      ],
      rules: {
        userID: [
          { required: true, message: "请输入 userID", trigger: "blur" },
          { validator: checkUserID, trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      registerVisible: false,
      loading: false,
    };
  },
  methods: {
    submit() {
      this.$refs["login"].validate((valid) => {
        if (valid) {
          this.login();
        }
      });
    },
    login() {
      this.loading = true;
      this.getAxios("http://8.140.150.245:8083/t/genUserSig", {
        userId: this.form.userID,
      }).then((res) => {
        localStorage.setItem("userSig", res.entity);
        this.tim
          .login({
            userID: this.form.userID,
            userSig: res.entity,
          })
          .then(() => {
            this.loading = false;
            this.$store.commit("toggleIsLogin", true);
            this.$store.commit("startComputeCurrent");
            this.$store.commit("showMessage", {
              type: "success",
              message: "登录成功",
            });
            this.$store.commit({
              type: "GET_USER_INFO",
              userID: this.form.userID,
              userSig: res.entity,
              sdkAppID: window.genTestUserSig("").SDKAppID,
            });
            this.$store.commit("showMessage", {
              type: "success",
              message: "登录成功",
            });
          })
          .catch((error) => {
            this.loading = false;
            this.$store.commit("showMessage", {
              message: "登录失败：" + error.message,
              type: "error",
            });
          });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.login-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 450px;
  background: $white;
  color: $black;
  border-radius: 5px;
  box-shadow: 0 11px 20px 0 rgba(0, 0, 0, 0.3);

  .row-div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }

  .loginBox {
    width: 320px;
    margin: 0 0 20px 0;

    .send-code {
      width: 112px;
    }

    .login-im-btn {
      width: 100%;
    }
  }

  .loginFooter {
    color: #8c8a8ac7;
    text-align: center;
    padding: 0 0 20px 0;
    cursor: pointer;
  }
}

.login-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 400px;
  padding: 20px 80px 50px;
  background: $white;
  color: $black;
  border-radius: 5px;
  box-shadow: 0 11px 20px 0 rgba(0, 0, 0, 0.3);

  .register-button {
    width: 100%;
    margin: 6px 0 0 0;
  }

  .user-selector {
    width: 100%;
  }
}
</style>
